const address = {
  'address.title': 'Address Management',
  'address.address': 'Shipping Address',
  'address.address.placeholder': 'Select shipping address',
  'address.add': 'Add',
  'address.addAddress': 'Add Address',
  'address.edit': 'Edit',
  'address.editAddress': 'Edit Address',
  'address.delete': 'Delete',
  'address.deleteAddress': 'Delete Address',
  'address.default': 'Default',
  'address.defaultAddress': 'Default Address',
  'address.setDefault': 'Set as Default',
  'address.setDefaultAddress': 'Set as Default Address',
  'address.switch': 'Switch',
  'address.switchAddress': 'Switch Address',

  'address.country': 'Country',
  'address.country.placeholder': 'Enter country',
  'address.country.maxLength': 'Country name cannot exceed {total} characters',

  'address.state': 'State/Province',
  'address.state.placeholder': 'Enter state/province',
  'address.state.maxLength': 'State/Province name cannot exceed {total} characters',

  'address.city': 'City',
  'address.city.placeholder': 'Enter city',
  'address.city.maxLength': 'City name cannot exceed {total} characters',

  'address.street': 'Street',
  'address.street.placeholder': 'Enter street',
  'address.street.maxLength': 'Street name cannot exceed {total} characters',

  'address.detail': 'Detailed Address',
  'address.detail.placeholder': 'Enter detailed address',
  'address.detail.maxLength': 'Detailed address cannot exceed {total} characters',

  'address.recipient_name': 'Recipient',
  'address.recipient_name.placeholder': 'Enter recipient name',
  'address.recipient_name.maxLength': 'Recipient name cannot exceed {total} characters',
  'address.recipient_name.minLength': 'Recipient name cannot be less than {total} characters',
  'address.recipient_name.pattern':
    'Recipient name can only contain Chinese, English letters, and spaces',

  'address.phone': 'Contact Number',
  'address.phone.placeholder': 'Enter contact number, e.g., +86 13800138000',
  'address.phone.maxLength': 'Contact number cannot exceed {total} characters',
  'address.phone.pattern': 'Please enter a valid phone number with country code',

  'address.postal_code': 'Postal Code',
  'address.postal_code.placeholder': 'Enter postal code',
  'address.postal_code.maxLength': 'Postal code cannot exceed {total} characters',
  'address.postal_code.pattern': 'Please enter a valid postal code',

  'address.updateSuccess': 'Address updated successfully',
  'address.createSuccess': 'Address added successfully',
  'address.deleteSuccess': 'Address deleted successfully',
  'address.setDefaultSuccess': 'Default address set successfully',

  'address.confirmDelete': 'Are you sure to delete this address?',
};

export default address;
